import Button from "devextreme-react/button";
import Popup, { ToolbarItem } from "devextreme-react/popup";
import { useContext, useState } from "react";
import { LoadPopupPanel } from "../../../../components";
import ActionHistoryGrid from "../../../common/action-history-grid/components/ActionHistoryGrid";
import { useGetROActionHistory } from "../api/get-action-history";
import { RetailOrderContext } from "../context/RetailOrderContext";


export default function ActionHistoryButton() {
	const [isPopupVisible, setPopupVisibility] = useState(false);

	const { order } = useContext(RetailOrderContext);

	const actionHistory = useGetROActionHistory(order.details.retailOrderID, isPopupVisible);

	return (
		<>
			<Button
				text="Action History"
				icon="Inscyth-Action-History"
				elementAttr={{ 'data-testid': 'btn-action-history' }}
				disabled={isPopupVisible}
				onClick={() => setPopupVisibility(true)}
			>
			</Button>
			<Popup
				title="Action History"
				visible={isPopupVisible}
				hideOnOutsideClick={true}
				onHiding={() => setPopupVisibility(false)}
			>
				<ToolbarItem
					options={{
						icon: 'dx-icon dx-icon-close',
						onClick: () => setPopupVisibility(false)
					}}
					widget="dxButton"
					location="after"
				/>
				{
					isPopupVisible &&
					<ActionHistoryGrid records={actionHistory.data} />
				}
				<LoadPopupPanel visible={actionHistory.isLoading}></LoadPopupPanel>
			</Popup>
		</>
	)
}
